/** has_ever_subscribed drives exit-offer eligibility (one intro per subscription group, as StoreKit). */
import { supabase } from '@/services/supabase';

export async function hasEverSubscribed(userID: string): Promise<boolean> {
  const { data } = await supabase().from('premium_entitlements').select('has_ever_subscribed').eq('user_id', userID).limit(1).maybeSingle();
  return !!(data as { has_ever_subscribed?: boolean } | null)?.has_ever_subscribed;
}

/** Polls `check` every `intervalMs` until it returns true or `timeoutMs` elapses. */
export async function pollUntil(check: () => Promise<boolean>, opts: { intervalMs: number; timeoutMs: number; isCancelled?: () => boolean; sleep?: (ms: number) => Promise<void> }): Promise<boolean> {
  const sleep = opts.sleep ?? ((ms: number) => new Promise<void>((r) => setTimeout(r, ms)));
  const attempts = Math.max(1, Math.floor(opts.timeoutMs / opts.intervalMs));
  for (let i = 0; i < attempts; i++) {
    if (opts.isCancelled?.()) return false;
    if (await check().catch(() => false)) return true;
    if (i < attempts - 1) await sleep(opts.intervalMs);
  }
  return false;
}
